import { Badge, Box, Icon } from '@palmetto/palmetto-components';

import EventBy from './EventBy';

const SabalOrganizationPaymentHoldChanged = ({ event }: { event: any }) => {
  const status = event.data.payoutHoldStatus === 'Active' ? 'set' : 'removed';

  return (
    <Box display="block">
      <EventBy event={event} /> {status} payment hold
      <Box alignItems="flex-start" direction="row" gap="sm" padding="sm 0">
        <Badge
          variant={event.data.payoutHoldStatus === 'Active' ? 'success' : 'warning'}
          key={`${event.id}-before`}
          message={event.data.payoutHoldStatus === 'Active' ? 'Hold Off' : 'Hold On'}
          size="md"
          color={event.data.payoutHoldStatus === 'Active' ? 'green' : 'red'}
        />
        <Icon name="arrow-right" />
        <Badge
          variant={event.data.payoutHoldStatus === 'Active' ? 'warning' : 'success'}
          key={`${event.id}-after`}
          message={event.data.payoutHoldStatus === 'Active' ? 'Hold On' : 'Hold Off'}
          size="md"
          color={event.data.payoutHoldStatus === 'Active' ? 'red' : 'green'}
        />
      </Box>
      <Box>{event.data.reason}</Box>
    </Box>
  );
};

export default SabalOrganizationPaymentHoldChanged;
